import { flattenObject } from './utils';
import InsertionChannelScene from "./InsertionChannelScene";

import A from './ActionCreators';
import { useDispatch, useStore } from 'react-redux';
import { createContext, useState, useReducer, useEffect} from 'react';
import G from './Getters';
import { TemplateEditingContext, ModalDispatch } from './Contexts';
import { updateNestedObject } from './utils';
import getDefaultMicroscopyTemplate from './DefaultMicroscopyTemplate';
import useNavbar from './useNavbar';

export function fullImageAnnotation(imageSetId){
  return `v_t=atn;geo=full;is=${imageSetId}`;
}


function Reducer(template,compactProps){
  return updateNestedObject(template,compactProps);
}

function getChannels(state,template,imageSetId,cellData){

  let { channels, channelGroupStructure } = template.compact;






  return Object.entries(channels).map(([channelId,channel]) => {
    return {
      ...channel,
      imageId:cellData?.imageIdsByChannel?.[channelId],
      channelId,
      imageSetId,
    }
  })


  let visibleChannelOrder = channelGroupStructure.flat();
  let allChannelIds = Object.keys(channels);

  let allChannels = [
    ...visibleChannelOrder,
    ...allChannelIds.filter(id => !visibleChannelOrder.includes(id))
  ];

  return allChannels.map(nodeId => {
    let channelGroup = template.compact.channels[nodeId]
    return ({ 
      nodeId,
      hidden:!visibleChannelOrder.includes(nodeId),
      channelGroup,
      imageId:cellData?.imageIdsByChannel?.[nodeId],
      imageSetId,
    })
  })

} 

function resolvedImageSetId(imageSetId,templateEvals){

  return imageSetId || templateEvals.find(x => x.imageSetId)?.imageSetId;
}

function resolvedRegionAssignments(unresolvedRegionAssignments,imageSetId,templateEvals){

  let isId = resolvedImageSetId(imageSetId,templateEvals);

  let resolved = Object.fromEntries(Object.entries(unresolvedRegionAssignments).map(([key,value]) => {

    if( value?.includes('is=') ){
      let replacedWithIs = value.split('is=');
      replacedWithIs[1] = isId;
      let finalAtnId = replacedWithIs.join('is=');
      return [
        key,
        finalAtnId
      ]
    }else{
      return [key,value]
    }
  }))


  return resolved;




}



export default function MicroscopyCropInsertion({ 
  initialState,
  figurePanelId, 
  useCase, 
  onSubmit, 
  onEvent,
  //cellData,
  cellLocation,
}){

  const dispatch = useDispatch();
  const store = useStore();
  const state = store.getState();

  if( !figurePanelId ){ }

  const cellData = G.getCellsValue(state,{figurePanelId,cells:[cellLocation]})[0];

  const [ template, _templateDispatch ] = useReducer(
    Reducer,

    figurePanelId ? G.getFigurePanelTemplate(state,{figurePanelId,cellLocation})
    :
    {
      compact:getDefaultMicroscopyTemplate(),
      ...G.getTemplateExpansion(null,getDefaultMicroscopyTemplate()),
    },
  );

  function templateDispatch(args){
    _templateDispatch(args);
  }



  const [imageSetId,setImageSetIdToInsert] = useState(G.getImageSetIdAtFigurePanelCell(state,{figurePanelId,cellLocation}));

  const [ imageInfoByChannelId, setImageInfoByChannelId ] = useState(cellData?.value || {});


  const [ tes, setTemplateEvals ] = useState(
    getChannels(state,template,imageSetId,cellData)
  )
  let templateEvals = Object.values(tes);

  if( !templateEvals.map ){
    debugger;
  }
  let imageIdsToMove = templateEvals.map(x => x.imageId).filter(x => x)

  const [ unresolvedRegionAssignments, setRegionAssignments ] = useState({
    main:(imageSetId && fullImageAnnotation(imageSetId)),
    ...(cellData?.regions||{})
  });


  const regionAssignments = resolvedRegionAssignments(unresolvedRegionAssignments, imageSetId, templateEvals);



  const [ focusedAnnotationId, setFocusedAnnotationId ] = useState(
    regionAssignments.main
  );

  function next(){

    //let imageIds = channels.map(x => x.imageId).filter(x => x);
    let isId = resolvedImageSetId(imageSetId,templateEvals); 

    let state = store.getState(); 

    let cellsValueArgs = {cells:[cellLocation],figurePanelId}
    let cellData = G.getCellsValue(state,cellsValueArgs)[0];
    let { localTemplateId } = cellData;


    if( localTemplateId ){
      let properties = flattenObject(template)
      let dispatchArgs ={
        figurePanelId,
        localTemplateId,
        properties,
      }
      dispatch(A.setTemplateProperties(dispatchArgs))
    }




    if( isId ){

      setImageSetIdToInsert(isId);
      setRegionAssignments({main:fullImageAnnotation(isId)});



      let imageIdsByChannel=Object.fromEntries(Object.keys(template.channels).map((channelId,ii) => ([channelId,templateEvals[ii].imageId])))

      let submitArgs={
        regions:regionAssignments,
        imageSetId:isId,
        imageIdsByChannel,
        template,

      }

      let moveImagesArgs = {
        imageIds:imageIdsToMove,
        destinationImageSetId:isId,
        annotationTransferOption:"keepBothAnnotations"
      }

      dispatch(A.moveImagesToImageSet(moveImagesArgs))

      onSubmit && onSubmit(submitArgs)


    }else{
      ;
    }
  }



  function onModalEvent(event){
    let { type } = event;
    switch(type){
        /*
      case "startTemplateEdit":{
        setEditingTemplateLayout(true);
        break;
      }
      */
      case "removeChannel":{

        //get parent of imageSetId
        //let filesystem

        //dispatch({
        break;
      }
      default:{
        throw Error(`No handled 'type' was given (${type})`);
      }
    }
  }



  let buttonEnabled = true;



  let nextButton = (
    <div>
      <button param={"true"} disabled={!buttonEnabled} action={"next"} onClick={next} class="btn btn-primary">Accept</button>
    </div>

  )


  let subSceneArgs = {

    imageInfoByChannelId,
    setImageInfoByChannelId,

    next,
    initialState,
    onEvent,
    cellLocation,
    cellData,
    channels:template.channels,
    templateEvals,
    setTemplateEvals,
    template,
    templateDispatch,
    setImageSetIdToInsert:function(args){
      setImageSetIdToInsert(args);
    },
    imageSetId,
    nextButton,
    focusedAnnotationId,
    regionAssignments,
    setRegionAssignments:(args) => {
      setRegionAssignments(args)
    },
    setFocusedAnnotationId
  }



  return (
    <>
      <TemplateEditingContext.Provider value={{...template,setTemplate:templateDispatch,regions:regionAssignments,setRegions:setRegionAssignments}}>
        <ModalDispatch.Provider value={{onModalEvent}}>

          <InsertionChannelScene {...subSceneArgs}/>

        </ModalDispatch.Provider>
      </TemplateEditingContext.Provider>
    </>
  )
}
